import React from 'react';
import { FaInternetExplorer, FaUserFriends, FaYoutube, FaGamepad, FaImages } from 'react-icons/fa';

export const APP_REGISTRY = {
  ie: {
    defaultWidth: 950,
    defaultHeight: 650,
    multi: true,
    getTitle: (props) => `${props.pageTitle || 'The Information Superhighway'} - Internet Exploder`,
    getIcon: () => <FaInternetExplorer size={14} color="#0078D7" />,
  },
  msn: {
    defaultWidth: 300,
    defaultHeight: 450,
    multi: false,
    getTitle: () => 'MSN Misdemeanor',
    getIcon: () => <FaUserFriends size={14} color="#00A2ED" />,
  },
  youtube: {
    defaultWidth: 854,
    defaultHeight: 520,
    multi: true,
    getTitle: (props) => `${props.title || 'Video'} - YouBoob`,
    getIcon: () => <FaYoutube size={14} color="#FF0000" />,
  },
  ruffle: {
    defaultWidth: 660,
    defaultHeight: 540,
    multi: true,
    getTitle: (props) => `${props.gameName || 'Flash Game'} - MegaFunExploit`,
    getIcon: () => <FaGamepad size={14} color="#FF6600" />,
  },
  pinball: {
    defaultWidth: 780,
    defaultHeight: 680,
    multi: false,
    getTitle: () => '3D Pinball - Space Cadet',
    getIcon: () => <FaGamepad size={14} color="#335DA8" />,
  },
  pictures: {
    defaultWidth: 920,
    defaultHeight: 640,
    multi: false,
    getTitle: () => 'My Pictures',
    getIcon: () => <FaImages size={14} color="#D9A323" />,
  },
};
